import {call, put, take} from "redux-saga/effects";
import {ActionType} from "typesafe-actions";
import {ResponseType} from "../../api/util";
import {Action as NotifyAction} from "../../NotificationSystem";
import * as Action from "../actions";

type FlowAction = ActionType<typeof Action.Command.setBoardTags>

export function* setBoardTagsFlow() {

    while (true) {
        const action: FlowAction = yield take([Action.Type.SET_BOARD_TAGS]);

        const {response, error}: ResponseType = yield call(Action.Api.setBoardTags, action.payload.board.uid, action.payload.board.tags);

        if (error) {
            yield put(NotifyAction.Command.error('Request Error', 'Could not set tags.'));
            yield put(Action.Query.fetchUserBoards());
        }

        if(response) {
            yield put(NotifyAction.Command.info('Tags set', ''));
        }
    }
}
